/* eslint-disable global-require,import/no-mutable-exports */
const config = require('../../config/config');

let Bugsnag;

const clientCheck = __CLIENT__ && !config.isTesting;

if (clientCheck) {
  /**
   * Bugsnag configuration variables
   */
  Bugsnag = require('bugsnag-js')({
    apiKey: process.env.BUGSNAG_JS_API_KEY,
    appVersion: process.env.APP_VERSION || '0.0.0',
    releaseStage: process.env.NODE_ENV,
    notifyReleaseStages: ['staging', 'production']
  });

  Bugsnag.beforeNotify = (/* payload, metaData */) => {
    // Any pre-notification filtering should happen here
  };
}

/**
 * Notify bugsnag of some information
 * @param error
 * @param description
 * @param metadata
 * @param severity - error, info, warning
 */
export const notify = (
  error,
  description,
  metadata = {},
  severity = 'error'
) => {
  if (clientCheck) {
    return Bugsnag.notify(error, description, metadata, severity);
  }
  return false;
};

/**
 * Notify bugsnag of a handled exception
 * @param exception
 */
export const notifyException = exception => {
  if (clientCheck) {
    Bugsnag.notifyException(exception);
  }
  return false;
};

/**
 * Set the current bugsnag userId
 */
export const setUser = user => {
  if (clientCheck) {
    Bugsnag.user = {
      id: user.id,
      name: user.firstName,
      email: user.email
    };
  }
};

export default Bugsnag;
